import styled, { css } from 'styled-components';

import _Tooltip from 'xpi-black-ui/Base/Tooltip';
import Row from 'xpi-black-ui/Base/Grid/Row/styles';
import { Th as _Th } from 'xpi-black-ui/Common/Table';
import _SectionTitle from 'xpi-black-ui/Common/SectionTitle';
import Td from 'xpi-black-ui/Common/Table/compose/Td/styles';
import Thead from 'xpi-black-ui/Common/Table/compose/Thead/styles';
import { Wrapper as Spinner}  from 'xpi-black-ui/Base/Spinner/styles';

export const Th = styled(_Th)`
  && {
    color: ${({ theme }) => theme.bgColor};
  }

  & > div[data-tooltip-text] {
    &:before {
      top: 30px;
    }
    &:after {
      top: 25px;
      border-bottom: 5px solid #2e3136;
      border-top: 0;
    }
  }
`;

export const TdFavotire = styled(Td)`
  position: relative;

  ${Spinner} {
    left: 8px;
  }
`;

export const EmptyInfo = styled.span`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: left;

  &:before {
    content: '--';
    display: block;
    color: #a2a3a7;
    letter-spacing: 4px;
  }
`;

export const TableWrapper = styled.div`
  height: 100%;

  &::-webkit-scrollbar-track {
    background-color: #eaeaea;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #636363;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c3c3c3;
  }

  ${Thead} {
    background: #ececec;
  }
`;

export const Input = styled.input`
  width: 80px;
  height: 27px;
  color: #A3A4A6;
  font-size: 12px;
  padding: 5px 8px;
  border: 1px solid #C3C4C5;

  ${({ error }) => error && css`
    border: solid 1px red;
  `};
`;

export const ClientWrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  padding: 0 24px;
  overflow-y: auto;
  background: white;
  flex-flow: column;
  position: relative;

  table {
    color: #76797c;

    label {
      display: inline-block;

      input {
        & ~ div {
          top: -12px;
          background-color: transparent;

          &:after {
            border-color: #fff;
          }
        }

        &:checked ~ div {
          background-color: #bbbbbd;
        }
      }
    }

    td, th {
      padding: 0;
      padding-left: 16px;

      &:last-child {
        padding-right: 16px;
      }
    }

    tbody {
      tr:nth-child(odd) td {
        background-color: transparent;
      }
      tr:nth-child(even) td {
        background-color: #eee;
      }
    }
  }
`;

export const SectionTitle = styled(_SectionTitle)`
  color: #3B3D42;
  border-bottom: 2px solid #ECEDED;
  padding-bottom: 18px;
  margin-bottom: 24px;
`;

export const ClientInfo = styled.div`
  width: 90%;
  max-width: 220px;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  text-overflow: ellipsis;
  text-transform: capitalize;
`;

export const ClientStatusWrapper = styled(Row)`
  i:before {
    color: #bbbbbd;
  }
`;

export const ClientStatus = styled.div`
  max-width: 400px;

  & > div > span {
    max-width: 400px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const TooltipStatus = styled(_Tooltip)`
  &[data-tooltip-text]:before {
    padding: 10px;
    height: inherit;
    max-width: 700px;
    line-height: 13px;
    width: fit-content;
    white-space: break-spaces;
  }
`;

export const TooltipError = styled(_Tooltip)`
  border: 0;
  width: 95px;
  bottom: 26px;
  display: block;

  &:before {
    content: attr(data-text);
    left: 50%;
    top: -50px;
    z-index: 1;
    width: auto;
    display: block;
    color: #6F7074;
    padding: 0 12px;
    font-size: 12px;
    margin: auto;
    height: 40px;
    line-height: 40px;
    position: absolute;
    white-space: nowrap;
    transform: translateX(-50%);
    background: white;
    border: solid 1px red;
  }

  &:after {
    content: '';
    left: 50%;
    top: -10px;
    margin: auto;
    display: block;
    position: absolute;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: solid 5px red;
  }
`;
